import { MenuItem } from "@blueprintjs/core"
import StaticSelector from "components/Atoms/StaticSelector"
import { COLOURS } from "data/static.items"
import React from "react"

const ColourSelector = ({ ...props }) => {
  return (
    <StaticSelector
      big
      renderText={item => {
        if (!item.id) return <span>Select Color</span>
        return (
          <span>
            <span
              style={{
                display: "inline-block",
                borderRadius: 4,
                background: item?.id,
                height: 12,
                width: 12,
                marginRight: 4,
              }}
            />
            {item.name}
          </span>
        )
      }}
      itemRenderer={(item, { handleClick, modifiers }) => {
        return (
          <MenuItem
            icon={
              <span
                style={{
                  borderRadius: 4,
                  background: item?.id,
                  height: 15,
                  width: 15,
                }}
              />
            }
            active={modifiers.active}
            key={item.id}
            onClick={handleClick}
            text={item?.name}
          />
        )
      }}
      label="Color"
      path="colorCode"
      {...props}
      items={COLOURS}
    />
  )
}

export default ColourSelector
